import { Input } from "antd";
import React, { useState, useEffect, useRef } from "react";
// import css from "./index.less";
import EnhanceTip from "./common/enhanceTip";
import { getDefaultComponentStyle } from "./utils/defaultStyles";

export default ({
  data,
  getText,
  setRetrieveValues,
  btnRequestHandle,
  setSubmitState,
  isStreaming,
}: {
  data: IMultiElementCombineMsg.IInputElem;
  getText: (text: IMultiElementCombineMsg.IText | undefined) => string;
  setRetrieveValues: (value: IMultiElementCombineMsg.IRetrieveValues) => void;
  btnRequestHandle: ({
    url,
    elem,
    extra,
  }: IMultiElementCombineMsg.ISubmitParams) => void;
  setSubmitState: (tipCheck: IMultiElementCombineMsg.ITipCheck) => void;
  isStreaming: boolean;
}) => {
  const {
    id,
    type,
    title,
    placeholder_title,
    default_text,
    disable,
    length,
    required,
    required_tips,
    prompt_tips,
    action_url,
    extra,
  } = data;
  const [inputVal, setInputVal] = useState(getText(default_text));
  const style = getDefaultComponentStyle(data);
  const originVal = useRef(inputVal);
  useEffect(() => {
    setInputVal(getText(default_text));
  }, [default_text]);

  useEffect(() => {
    setRetrieveValues({ id, type, value: inputVal });
  }, [inputVal]);

  const inputChange = (e: any) => {
    if (!e || !e.target) return;

    const value = e.target.value;
    updateVal(value);
  };

  const inputBlur = () => {
    const trimVal = inputVal.trim();
    if (originVal.current === inputVal) return;

    updateVal(trimVal);
    if (originVal.current !== trimVal) {
      originVal.current = trimVal;

      // if (required && !trimVal) return;
      action_url &&
        btnRequestHandle({
          url: action_url,
          elem: { id, type, value: trimVal },
          extra,
        });
    }
  };

  const updateVal = (value: string) => {
    setInputVal(value);
  };

  return (
    <div style={style}>
      <EnhanceTip
        id={id}
        isEmpty={!inputVal}
        required={required}
        required_tips={required_tips}
        prompt_tips={prompt_tips}
        isLeftGap={!!getText(title)}
        setSubmitState={setSubmitState}
      >
        <div className={"sscard-flexBox"}>
          {getText(title) && <span className={"desc"}>{getText(title)}</span>}
          <Input
            className={`${"selectItem"}`}
            disabled={isStreaming || !!disable}
            placeholder={getText(placeholder_title)}
            onChange={inputChange}
            onBlur={inputBlur}
            onClick={(e) => e.stopPropagation()}
            value={inputVal}
            maxLength={length}
          />
        </div>
      </EnhanceTip>
    </div>
  );
};
